import { Box, Grid, makeStyles, CircularProgress } from "@material-ui/core";
export const CircularProggressIndicator = () => {
  const classes = useStyles();

  return (
    <Box className={classes.component}>
      <Grid container justifyContent="center">
        <CircularProgress />
      </Grid>
    </Box>
  );
};
const useStyles = makeStyles({
  component: {
    width: "100%",
    padding: "50px",
  },
});
